const langDropDownTheme = {
    color: '#fff',

    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
}

export default langDropDownTheme
